import type { CSSProperties } from 'react';
import { useHistory } from 'react-router-dom';

interface LogoLinkProps {
  className?: string;
  style?: CSSProperties;
}

/**
 * Clickable BluePages logo. Navigates to the home page (`/home`) so users can
 * always get back from any deep link (profile/job detail, dashboards, etc.).
 *
 * Brand wordmark: `public/logos/BluePages-logo.png` (wide lockup on ink navy).
 * Height-driven sizing (`height: 28px` / `32px`) keeps aspect ratio 1983×793.
 *
 * @see applications/bp-mobile-web-pwa/public/logos/BluePages-logo.png
 */
export function LogoLink({ className, style }: LogoLinkProps) {
  const history = useHistory();
  return (
    <a
      href="/home"
      aria-label="BluePages home"
      style={{ display: 'inline-flex', cursor: 'pointer' }}
      onClick={(e) => {
        e.preventDefault();
        history.push('/home');
      }}
    >
      <img
        src="/logos/BluePages-logo.png"
        alt="BluePages"
        className={className}
        style={{ borderRadius: 8, ...style }}
      />
    </a>
  );
}
